import React, { useMemo } from "react";
import SortingStage from "../stages/SortingStage";
import marketRack from "../../../assets/game/market-rack.jpg";
import marketMobileRack from "../../../assets/game/market-mobile-rack.png";
import StagePageLayout from "./StagePageLayout";

export default function SupermarketStagePage({ stage, onDone, onSessionPointsChange }) {
  const data = useMemo(
    () => ({
      ...stage.data,
      pointsPerItem: 5,
      rackImage: marketRack,
      mobileRackImage: marketMobileRack,
      /** Fallback if callers only set `background`. */
      background: marketRack,
    }),
    [stage]
  );
  return (
    <StagePageLayout stageId={stage.id} theme={stage.theme}>
      <SortingStage data={data} onDone={onDone} onSessionPointsChange={onSessionPointsChange} />
    </StagePageLayout>
  );
}
